import { useNavigate, useSearchParams } from "react-router-dom";

export const useNavigateToRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return () => {
    const redirect = searchParams.get("r") || 'https://play.pocketfilms.in';

    if (redirect?.startsWith("http")) {
      window.location.replace(redirect!);
    } else {
      navigate(redirect || "/");
    }
  };
};